var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCreateEmployeeProfile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 147.773,
    height: 201.483,
    viewBox: "0 0 147.773 201.483",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_22347",
    "data-name": "Group 22347",
    transform: "translate(-890.373 -216.565)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11431",
    "data-name": "Path 11431",
    d: "M147.773,352.121c0,4.145-33.08,7.5-73.886,7.5S0,356.266,0,352.121s33.08-7.5,73.886-7.5,73.886,3.36,73.886,7.5",
    transform: "translate(890.373 58.422)",
    fill: "#7586ec",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_22346",
    "data-name": "Group 22346",
    transform: "translate(896.711 197.733)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22314",
    "data-name": "Group 22314",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22282",
    "data-name": "Group 22282",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22279",
    "data-name": "Group 22279",
    transform: "translate(0 18.832)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11376",
    "data-name": "Path 11376",
    d: "M1122.222,440.177h112.239a11.628,11.628,0,0,1,11.429,11.751V610.565a11.627,11.627,0,0,1-11.429,11.751H1122.222a11.626,11.626,0,0,1-11.428-11.751V451.928A11.627,11.627,0,0,1,1122.222,440.177Z",
    transform: "translate(-1110.794 -440.177)",
    fill: "#e2e9fb",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22280",
    "data-name": "Group 22280",
    transform: "translate(8.092 26.628)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2023",
    "data-name": "Rectangle 2023",
    width: 159.161,
    height: 116.442,
    rx: 15,
    transform: "translate(0 159.156) rotate(-89.546)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_22283",
    "data-name": "Group 22283",
    transform: "translate(41.938 54.012)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11378",
    "data-name": "Path 11378",
    d: "M1397.092,645.833h75.338a.548.548,0,0,1,.525.567h0a.55.55,0,0,1-.525.568h-75.338a.549.549,0,0,1-.525-.568h0A.548.548,0,0,1,1397.092,645.833Z",
    transform: "translate(-1396.567 -645.833)",
    fill: "#d2e5f7",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22284",
    "data-name": "Group 22284",
    transform: "translate(35.751 88.305)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11379",
    "data-name": "Path 11379",
    d: "M1354.974,879.51h81.438a.569.569,0,0,1,.568.568h0a.571.571,0,0,1-.568.568h-81.438a.571.571,0,0,1-.568-.568h0A.57.57,0,0,1,1354.974,879.51Z",
    transform: "translate(-1354.406 -879.51)",
    fill: "#d2e5f7",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22287",
    "data-name": "Group 22287",
    transform: "translate(20.747 84.083)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22285",
    "data-name": "Group 22285"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11380",
    "data-name": "Path 11380",
    d: "M1252.769,854.836a3.49,3.49,0,1,1,3.49,3.49,3.49,3.49,0,0,1-3.49-3.49Zm3.49,4.092a4.092,4.092,0,1,0-4.092-4.092A4.092,4.092,0,0,0,1256.26,858.929Z",
    transform: "translate(-1252.167 -850.744)",
    fill: "#040227",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22286",
    "data-name": "Group 22286",
    transform: "translate(2.206 2.206)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11381",
    "data-name": "Path 11381",
    d: "M1269.084,865.775a1.887,1.887,0,1,0,1.887,1.886A1.886,1.886,0,0,0,1269.084,865.775Z",
    transform: "translate(-1267.197 -865.775)",
    fill: "#040227",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_22288",
    "data-name": "Group 22288",
    transform: "translate(35.751 105.452)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11382",
    "data-name": "Path 11382",
    d: "M1354.974,996.356h66.193a.569.569,0,0,1,.568.567h0a.571.571,0,0,1-.568.568h-66.193a.571.571,0,0,1-.568-.568h0A.569.569,0,0,1,1354.974,996.356Z",
    transform: "translate(-1354.406 -996.356)",
    fill: "#d2e5f7",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22291",
    "data-name": "Group 22291",
    transform: "translate(20.747 101.23)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22289",
    "data-name": "Group 22289"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11383",
    "data-name": "Path 11383",
    d: "M1252.769,971.677a3.49,3.49,0,1,1,3.49,3.49,3.489,3.489,0,0,1-3.49-3.49Zm3.49,4.092a4.093,4.093,0,1,0-4.092-4.092A4.093,4.093,0,0,0,1256.26,975.769Z",
    transform: "translate(-1252.167 -967.583)",
    fill: "#040227",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22290",
    "data-name": "Group 22290",
    transform: "translate(2.206 2.206)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11384",
    "data-name": "Path 11384",
    d: "M1269.084,982.614a1.887,1.887,0,1,0,1.887,1.888A1.887,1.887,0,0,0,1269.084,982.614Z",
    transform: "translate(-1267.197 -982.614)",
    fill: "#040227",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_22292",
    "data-name": "Group 22292",
    transform: "translate(35.751 122.598)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11385",
    "data-name": "Path 11385",
    d: "M1354.974,1113.2h49.849a.569.569,0,0,1,.568.568h0a.572.572,0,0,1-.568.568h-49.849a.572.572,0,0,1-.568-.568h0A.569.569,0,0,1,1354.974,1113.2Z",
    transform: "translate(-1354.406 -1113.195)",
    fill: "#d2e5f7",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22295",
    "data-name": "Group 22295",
    transform: "translate(20.747 118.376)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22293",
    "data-name": "Group 22293"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11386",
    "data-name": "Path 11386",
    d: "M1252.769,1088.516a3.49,3.49,0,1,1,3.49,3.49,3.49,3.49,0,0,1-3.49-3.49Zm3.49,4.092a4.093,4.093,0,1,0-4.092-4.092A4.093,4.093,0,0,0,1256.26,1092.608Z",
    transform: "translate(-1252.167 -1084.422)",
    fill: "#040227",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22294",
    "data-name": "Group 22294",
    transform: "translate(2.206 2.207)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11387",
    "data-name": "Path 11387",
    d: "M1269.084,1099.46a1.886,1.886,0,1,0,1.887,1.886A1.886,1.886,0,0,0,1269.084,1099.46Z",
    transform: "translate(-1267.197 -1099.46)",
    fill: "#040227",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_22296",
    "data-name": "Group 22296",
    transform: "translate(35.751 139.746)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11388",
    "data-name": "Path 11388",
    d: "M1354.974,1230.042h81.438a.569.569,0,0,1,.568.567h0a.57.57,0,0,1-.568.568h-81.438a.57.57,0,0,1-.568-.568h0A.569.569,0,0,1,1354.974,1230.042Z",
    transform: "translate(-1354.406 -1230.042)",
    fill: "#d2e5f7",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22299",
    "data-name": "Group 22299",
    transform: "translate(20.747 135.523)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22297",
    "data-name": "Group 22297"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11389",
    "data-name": "Path 11389",
    d: "M1252.769,1205.36a3.49,3.49,0,1,1,3.49,3.49,3.49,3.49,0,0,1-3.49-3.49Zm3.49,4.094a4.093,4.093,0,1,0-4.092-4.094A4.093,4.093,0,0,0,1256.26,1209.454Z",
    transform: "translate(-1252.167 -1201.268)",
    fill: "#040227",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22298",
    "data-name": "Group 22298",
    transform: "translate(2.206 2.206)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11390",
    "data-name": "Path 11390",
    d: "M1269.084,1216.3a1.887,1.887,0,1,0,1.887,1.887A1.887,1.887,0,0,0,1269.084,1216.3Z",
    transform: "translate(-1267.197 -1216.299)",
    fill: "#040227",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_22300",
    "data-name": "Group 22300",
    transform: "translate(35.751 156.892)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11391",
    "data-name": "Path 11391",
    d: "M1354.974,1346.881h73.835a.57.57,0,0,1,.568.567h0a.572.572,0,0,1-.568.569h-73.835a.572.572,0,0,1-.568-.569h0A.569.569,0,0,1,1354.974,1346.881Z",
    transform: "translate(-1354.406 -1346.881)",
    fill: "#d2e5f7",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22303",
    "data-name": "Group 22303",
    transform: "translate(20.747 152.669)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22301",
    "data-name": "Group 22301"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11392",
    "data-name": "Path 11392",
    d: "M1252.769,1322.2a3.49,3.49,0,1,1,3.49,3.49,3.491,3.491,0,0,1-3.49-3.49Zm3.49,4.093a4.093,4.093,0,1,0-4.092-4.093A4.093,4.093,0,0,0,1256.26,1326.292Z",
    transform: "translate(-1252.167 -1318.106)",
    fill: "#040227",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22302",
    "data-name": "Group 22302",
    transform: "translate(2.206 2.206)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11393",
    "data-name": "Path 11393",
    d: "M1269.084,1333.138a1.887,1.887,0,1,0,1.887,1.887A1.887,1.887,0,0,0,1269.084,1333.138Z",
    transform: "translate(-1267.197 -1333.138)",
    fill: "#040227",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_22304",
    "data-name": "Group 22304",
    transform: "translate(35.751 174.038)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11394",
    "data-name": "Path 11394",
    d: "M1354.974,1463.719h81.438a.57.57,0,0,1,.568.568h0a.571.571,0,0,1-.568.568h-81.438a.571.571,0,0,1-.568-.568h0A.57.57,0,0,1,1354.974,1463.719Z",
    transform: "translate(-1354.406 -1463.719)",
    fill: "#d2e5f7",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22307",
    "data-name": "Group 22307",
    transform: "translate(20.747 169.817)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22305",
    "data-name": "Group 22305"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11395",
    "data-name": "Path 11395",
    d: "M1252.769,1439.045a3.49,3.49,0,1,1,3.49,3.49,3.49,3.49,0,0,1-3.49-3.49Zm3.49,4.092a4.092,4.092,0,1,0-4.092-4.092A4.092,4.092,0,0,0,1256.26,1443.138Z",
    transform: "translate(-1252.167 -1434.953)",
    fill: "#040227",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22306",
    "data-name": "Group 22306",
    transform: "translate(2.206 2.206)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11396",
    "data-name": "Path 11396",
    d: "M1269.084,1449.984a1.886,1.886,0,1,0,1.887,1.887A1.886,1.886,0,0,0,1269.084,1449.984Z",
    transform: "translate(-1267.197 -1449.984)",
    fill: "#040227",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_22308",
    "data-name": "Group 22308",
    transform: "translate(26.262 35.713)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11397",
    "data-name": "Path 11397",
    d: "M1290.316,521.139h81.438c.313,0,.568,1.559.568,3.465h0c0,1.909-.258,3.468-.568,3.468h-81.438c-.311,0-.568-1.559-.568-3.468h0C1289.748,522.7,1290,521.139,1290.316,521.139Z",
    transform: "translate(-1289.748 -521.139)",
    fill: "#d2e5f7",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22309",
    "data-name": "Group 22309",
    transform: "translate(17.642 53.673)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11398",
    "data-name": "Path 11398",
    d: "M1231.139,643.521h18.01c.069,0,.126,4.547.126,10.1h0c0,5.568-.057,10.115-.126,10.115h-18.01c-.069,0-.126-4.546-.126-10.115h0C1231.013,648.068,1231.07,643.521,1231.139,643.521Z",
    transform: "translate(-1231.013 -643.521)",
    fill: "#d2e5f7",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22310",
    "data-name": "Group 22310",
    transform: "translate(41.938 58.703)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11399",
    "data-name": "Path 11399",
    d: "M1397.092,677.8h75.338a.549.549,0,0,1,.525.568h0a.55.55,0,0,1-.525.568h-75.338a.549.549,0,0,1-.525-.568h0A.549.549,0,0,1,1397.092,677.8Z",
    transform: "translate(-1396.567 -677.798)",
    fill: "#d2e5f7",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22311",
    "data-name": "Group 22311",
    transform: "translate(41.938 63.387)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11400",
    "data-name": "Path 11400",
    d: "M1397.092,709.716h75.338a.549.549,0,0,1,.525.568h0a.551.551,0,0,1-.525.568h-75.338a.55.55,0,0,1-.525-.568h0A.549.549,0,0,1,1397.092,709.716Z",
    transform: "translate(-1396.567 -709.716)",
    fill: "#d2e5f7",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22312",
    "data-name": "Group 22312",
    transform: "translate(41.938 68.071)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11401",
    "data-name": "Path 11401",
    d: "M1397.092,741.633h75.338a.549.549,0,0,1,.525.567h0a.551.551,0,0,1-.525.569h-75.338a.55.55,0,0,1-.525-.569h0A.549.549,0,0,1,1397.092,741.633Z",
    transform: "translate(-1396.567 -741.633)",
    fill: "#d2e5f7",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22313",
    "data-name": "Group 22313",
    transform: "translate(41.938 72.755)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11402",
    "data-name": "Path 11402",
    d: "M1396.97,773.55h57.813c.221,0,.4.255.4.567h0c0,.313-.182.568-.4.568H1396.97c-.221,0-.4-.255-.4-.568h0C1396.567,773.8,1396.748,773.55,1396.97,773.55Z",
    transform: "translate(-1396.567 -773.55)",
    fill: "#d2e5f7",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_22317",
    "data-name": "Group 22317",
    transform: "translate(21.888 57.569)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22315",
    "data-name": "Group 22315",
    transform: "translate(2.208)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11403",
    "data-name": "Path 11403",
    d: "M1280.289,672.7a2.652,2.652,0,1,1-2.671-2.634A2.651,2.651,0,0,1,1280.289,672.7Z",
    transform: "translate(-1274.984 -670.071)",
    fill: "#fefefe",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22316",
    "data-name": "Group 22316",
    transform: "translate(0 6.212)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11404",
    "data-name": "Path 11404",
    d: "M1264.826,712.4h0a4.921,4.921,0,0,0-4.885,4.956h0a1.29,1.29,0,0,0,1.3,1.282l7.259-.052a1.291,1.291,0,0,0,1.282-1.3h0A4.922,4.922,0,0,0,1264.826,712.4Z",
    transform: "translate(-1259.941 -712.402)",
    fill: "#fefefe",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_22345",
    "data-name": "Group 22345",
    transform: "translate(38.037 48.358)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22343",
    "data-name": "Group 22343",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22318",
    "data-name": "Group 22318",
    transform: "translate(34.419 76.446)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11405",
    "data-name": "Path 11405",
    d: "M1609.118,1133.607a7.628,7.628,0,0,0-1.717,1.24c-.224.24-.467.543-.923,1.061a6.767,6.767,0,0,0-.621.751,10.6,10.6,0,0,0-.666,1.53c-.407.962-.785,1.182-.63,1.567a6.541,6.541,0,0,0,.472.646,4.952,4.952,0,0,1,.343.939c.169.016.341.033.507.045l.945-1.335.339,2.318-.808.322a1,1,0,0,0-1.575.325c.207.244.487.6.778.9a1.4,1.4,0,0,0,.647.448.887.887,0,0,0,.405-.027,5.048,5.048,0,0,0,1.674.55,3.531,3.531,0,0,0,1.142.217c.141-.008.359-.033.556-.053-.164.411-.057.486.245.709a13.583,13.583,0,0,0,1.635-1.012,9.214,9.214,0,0,1,1.181-1.784,13.789,13.789,0,0,1,.305-2.373,15.955,15.955,0,0,0,.279-2.739c.057-2.719.27-1.433-.333-4.252a24.412,24.412,0,0,1-.4-5.239l-3.8-.137A10.113,10.113,0,0,1,1609.118,1133.607Z",
    transform: "translate(-1604.525 -1128.226)",
    fill: "#ffb27d",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22319",
    "data-name": "Group 22319",
    transform: "translate(35.143 152.397)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11406",
    "data-name": "Path 11406",
    d: "M1609.454,1650a9.264,9.264,0,0,0,.4,2.856,20.546,20.546,0,0,0,5.791.2,11.431,11.431,0,0,0,5.661,2.358c1.9.329,5.317.218,6.6-.484a1.242,1.242,0,0,0,.764-1.09c0-.582.03-1.16-.845-1.369a17.565,17.565,0,0,1-5.14-2.472c.258-.87-.628-1.437-1.589-2.256-.642-.551-1.456-1.531-1.949-1.968l-7.361,1.652Z",
    transform: "translate(-1609.454 -1645.776)",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22321",
    "data-name": "Group 22321",
    transform: "translate(12.92 152.941)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11408",
    "data-name": "Path 11408",
    d: "M1458.3,1658.411c.458,1.17,1.422,1.671,3.713,2.333,1.277.368,3.848.388,4.563-.4a4.933,4.933,0,0,0,.744-3.344c-.209-1.651-2.416-4.463-2.381-7.521l-5.75.284-1.167,2.05C1458.273,1653.553,1457.952,1657.512,1458.3,1658.411Z",
    transform: "translate(-1458.023 -1649.48)",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22323",
    "data-name": "Group 22323",
    transform: "translate(8.501 73.085)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11410",
    "data-name": "Path 11410",
    d: "M1430.971,1105.324c-2.444,10.091-4.424,10.181-1.85,22.526l6.114-8.687.161-10.941Z",
    transform: "translate(-1427.914 -1105.324)",
    fill: "#3b5bb3",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22324",
    "data-name": "Group 22324",
    transform: "translate(8.904 77.35)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11411",
    "data-name": "Path 11411",
    d: "M1431.988,1143.477l1.971-7.565-.885-1.4-.442-.122-1.971,6.358A14.155,14.155,0,0,1,1431.988,1143.477Z",
    transform: "translate(-1430.66 -1134.386)",
    fill: "#f7a695",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22325",
    "data-name": "Group 22325",
    transform: "translate(15.855 11.437)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11412",
    "data-name": "Path 11412",
    d: "M1480.559,690.959l.273-3.256a7.439,7.439,0,0,1-1.081-1.183c-.719-1.189-1.194-1.609-1.549-1.008-.171.127-.231.533-.131,1.037.174.883.732,2.2.909,2.977C1479.12,690.151,1479.935,692.285,1480.559,690.959Z",
    transform: "translate(-1478.023 -685.239)",
    fill: "#ffb27d",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22326",
    "data-name": "Group 22326",
    transform: "translate(8.797 20.492)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11413",
    "data-name": "Path 11413",
    d: "M1456.461,758.575l-4.747-.218-16.274-1.166-5.511-.045c5.168.444,9.683-4.123,10.207-5.56a9.729,9.729,0,0,0,.328-4.494l4.572.33,4.543-.479C1448.934,752.377,1451.523,756.462,1456.461,758.575Z",
    transform: "translate(-1429.929 -746.944)",
    fill: "#ffb27d",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22327",
    "data-name": "Group 22327",
    transform: "translate(18.01 20.49)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11414",
    "data-name": "Path 11414",
    d: "M1492.711,752.458a1.888,1.888,0,0,0,.993-.884,10.391,10.391,0,0,0,.3-4.645l4.6.481,4.543-.479c-.011.057-.052.725-.078.912a4.455,4.455,0,0,0-.017.463,3.281,3.281,0,0,1-.524.529,5.285,5.285,0,0,0-.717.689,14.655,14.655,0,0,1-1.049,1.437,7.412,7.412,0,0,1-3.21,1.332A11.42,11.42,0,0,1,1492.711,752.458Z",
    transform: "translate(-1492.711 -746.929)",
    fill: "#fca56b",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22328",
    "data-name": "Group 22328",
    transform: "translate(17.269 3.027)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11415",
    "data-name": "Path 11415",
    d: "M1494.363,648.626h-.079a4.72,4.72,0,0,1-2-.231c-.517-.222-.767-.726-1.476-1.41a9.07,9.07,0,0,1-1.737-2.275,10.328,10.328,0,0,1-.656-2.7,29.224,29.224,0,0,1-.743-3.1c-.062-1.16.123-2.326.086-3.632a16.967,16.967,0,0,1,.081-3.242,3.818,3.818,0,0,1,1.255-2.323v0a6.548,6.548,0,0,1,1.378-.926l.015-.007c.032-.013.067-.028.1-.045l.055-.031c.027-.01.054-.025.08-.035s.05-.025.078-.035.057-.023.084-.038.049-.021.075-.032a.881.881,0,0,1,.108-.04l.053-.025c.05-.022.107-.038.161-.058v0a8.965,8.965,0,0,1,4.317-.4,7.322,7.322,0,0,1,3.807,1.673,3.807,3.807,0,0,1,1.245,2.313,16.816,16.816,0,0,1,.09,3.227c-.039,1.307.151,2.468.09,3.623a29.593,29.593,0,0,1-.735,3.092,10.744,10.744,0,0,1-.981,2.858,7.078,7.078,0,0,1-1.393,2.124c-.7.69-.953,1.2-1.466,1.425A4.464,4.464,0,0,1,1494.363,648.626Z",
    transform: "translate(-1487.656 -627.935)",
    fill: "#ffb27d",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22329",
    "data-name": "Group 22329",
    transform: "translate(0 23.274)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11416",
    "data-name": "Path 11416",
    d: "M1388.99,765.9c-.339,1.073-.705,2.012-1.125,3.056-2.377.878-4.984,2.4-6.7,2.763-6.665,1.436-7.69,4-7.944,10.188-1.167,5.914-2.038,11.625-2.9,17.547a13.3,13.3,0,0,0-.062,5.732c.959,6.879,1.914,10.542,5.532,16.825l2.855,5.307c2.371-1.661,2.909-5.555,2.776-7.763l-1.248-2.294c-.748-4.83-.49-9.276-1.167-14.115,1.01-8.385,2.364-8.343,3.3-18.9l5.63,2.172,8.85,3.46,9.436,9.577-.473,5.629c.613,2.531.987,6.725,1.4,9.022.286,1.6.369,3.2.64,4.852.139.842.772,1.639.861,2.252.113.769.223,1.561.34,2.377,3.247,1.226,2.315.89,4.9,3.211.07-1.534.133-3.051.183-4.562.023-.744.779-1.4.908-2.132.345-1.955-.266-3.7-.252-5.5.04-4.427-.02-8.849-.187-13.4-.231-6.334-2.249-12.711-2.383-18.4.322-5.75-.89-8.113-5.284-9.139-1.945-.858-4.2-1.593-6.7-2.935l-1.087-3.058c-1.116,2.824-1.493,3.036-3.5,5.311C1391.305,770.1,1389.235,767.9,1388.99,765.9Z",
    transform: "translate(-1369.984 -765.903)",
    fill: "#040227",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22330",
    "data-name": "Group 22330",
    transform: "translate(10.663 38.157)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11417",
    "data-name": "Path 11417",
    d: "M1443.024,867.319l-.322.96c-.032,3.813.562,7.589.248,11.467-.8,9.852.173,14.371.637,20.149l.4,4.428,20.433,2.572c.7-1.983,1.539-3.738,2.131-5.752-.086-4.422,1.683-7.928,2.4-15.45.611-6.383,1.02-11.02-1-16.766l-8.2-.484Z",
    transform: "translate(-1442.644 -867.319)",
    fill: "#040227",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22331",
    "data-name": "Group 22331",
    transform: "translate(34.512 39.766)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11418",
    "data-name": "Path 11418",
    d: "M1605.214,910.494c-.054-2.854.662-5.327,1.371-8.745.514,2.544.856,6.167,1.225,8.239.287,1.6.369,3.2.64,4.851.14.842.774,1.639.86,2.252.113.769.223,1.561.34,2.378.285.107.538.2.765.289a21.16,21.16,0,0,0-.405-2.907,7.116,7.116,0,0,0,2.184.151c-3.922-.963-2.558-4.725-3.132-8.863a107.873,107.873,0,0,1-1.276-14.881c.5-5.494.66-9.785-1.165-14.98h-.588c1.953,5.672.743,10.2.136,16.525A79.806,79.806,0,0,0,1605.214,910.494Z",
    transform: "translate(-1605.153 -878.278)",
    fill: "#262d4e",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22332",
    "data-name": "Group 22332",
    transform: "translate(10.379 38.236)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11419",
    "data-name": "Path 11419",
    d: "M1441.937,867.855l.323,3.622c-.034,3.806-.767,4.81-1.082,8.687a122.138,122.138,0,0,0-.39,14.461c.123,2.415,1.193,4,1.149,5.728l.4,4.428,2.508-3.983c-3.235-2.285-2.323-12.191-1.575-16.554a44.4,44.4,0,0,0,.575-6.939A19.173,19.173,0,0,0,1441.937,867.855Z",
    transform: "translate(-1440.711 -867.855)",
    fill: "#262d4e",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22333",
    "data-name": "Group 22333",
    transform: "translate(8.879 73.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11420",
    "data-name": "Path 11420",
    d: "M1433.142,1109.852c1.4,5.468-1.882,11.956-2.654,14.561.113,7.972.336,16.8.589,24.728.234,7.341.238,15.519.772,22.869.321,4.414.906,8.662,1.318,13.045.271,2.874-.065,5.162.859,8.354,2.255-2.834,4.144-3.441,8.528-2.172,2.006-6.042-.981-13.323-1.27-20.028-.1-2.353-.326-7.836-.324-10.219.012-4.563-.516-5.071-.014-10.08.2-1.2.41-2.356.621-3.493a185.981,185.981,0,0,1,4.446-19.3c2.39,8.125,5.179,17.11,7.4,25.285.162,2.868-.027,5.637.482,9.518s1.849,10.657,2.093,14.481-.526,6.855-.4,8.2c.189,2.093,1.046,4.309.884,7.32,4.233.338,4.746-3.056,10.537-4.184-1.642-4.38-.823-2.373-.963-6.275-.3-8.333-1.162-17.778-2.012-26.092a38.711,38.711,0,0,0,0-6.353l-1.529-13.7c-.7-5.055-.98-10.612-1.77-16.172-1.706-3.26-2.835-6.257-4.264-9.654l-6.837.725-15.606-1.284Z",
    transform: "translate(-1430.488 -1109.852)",
    fill: "#699dee",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22334",
    "data-name": "Group 22334",
    transform: "translate(20.617 78.221)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11421",
    "data-name": "Path 11421",
    d: "M1514.215,1154.255l.042-.142c2.39,8.124,5.144,16.63,7.366,24.8.16,2.871.032,5.461.541,9.342s1.908,11.342,2.151,15.164-.7,6.559-.58,7.907c.19,2.094,1.141,4.584.979,7.6a5.664,5.664,0,0,0,2.7-.388,18.85,18.85,0,0,1-1.6-6.932c-.227-2.839.86-4.347.846-5.617-.088-8.3-3.249-18.954-2.4-26.052-2.9-9.277-5.391-16.971-7.487-26.46-3.868-2.174-4.481-4.875-6.311-13.153.054,1.17.117,2.309.2,3.345C1511.123,1149.674,1512.057,1153.424,1514.215,1154.255Z",
    transform: "translate(-1510.47 -1140.321)",
    fill: "#6392dc",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22335",
    "data-name": "Group 22335",
    transform: "translate(16.985 23.394)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11422",
    "data-name": "Path 11422",
    d: "M1487.73,766.719a14.37,14.37,0,0,1-2,3.4c-.126.864,1.272,3.663,4.112,6.679-1.814-2.894-3.7-5.135-3.435-6.444.242-.566,1.038-2.02,1.565-2.909Z",
    transform: "translate(-1485.723 -766.719)",
    fill: "#262d4e",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22336",
    "data-name": "Group 22336",
    transform: "translate(21.032 29.759)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11423",
    "data-name": "Path 11423",
    d: "M1513.3,813.861a23.186,23.186,0,0,1,3.44-3.77l1.6.148c1.314.894,1.92,1.376,2.845,4.528l-1.709-1.651-2-1.123-1.017.144-1.059.558A19.951,19.951,0,0,0,1513.3,813.861Z",
    transform: "translate(-1513.302 -810.091)",
    fill: "#61a0e0",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22337",
    "data-name": "Group 22337",
    transform: "translate(22.831 29.778)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11424",
    "data-name": "Path 11424",
    d: "M1527.194,810.276a9.255,9.255,0,0,0-1.636,1.673,14.766,14.766,0,0,0,1.43,1.932l.019.944c.066,8.254-.653,17.862-.911,26.134l3.3,3.782,2.189-4.253c.19-7.315-1.163-18.31-2.183-26.367a6.146,6.146,0,0,1,1.038-1.97,6.129,6.129,0,0,0-1.74-1.9A7,7,0,0,0,1527.194,810.276Z",
    transform: "translate(-1525.557 -810.221)",
    fill: "#699dee",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22338",
    "data-name": "Group 22338",
    transform: "translate(8.879 73.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11425",
    "data-name": "Path 11425",
    d: "M1433.142,1109.852c1.4,5.468-1.882,11.956-2.654,14.561.113,7.972.336,16.8.589,24.728.234,7.341.238,15.519.772,22.869.321,4.414.906,8.662,1.318,13.045.271,2.874-.065,5.162.859,8.354a11.464,11.464,0,0,1,1.293-1.4c-.138-2.607-.325-5.172-.636-7.881A210.338,210.338,0,0,1,1433,1159.75c-.011-10.737.069-23.058-.362-33.962,1.525-7.881,2.274-8.46.943-15.893Z",
    transform: "translate(-1430.488 -1109.852)",
    fill: "#6392dc",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22340",
    "data-name": "Group 22340",
    transform: "translate(15.256)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11427",
    "data-name": "Path 11427",
    d: "M1484.759,614.341c-2.107-.177-8.041-1.35-7.054,2.03l-.535-.531a8.81,8.81,0,0,0-.32,2.937l-.641-.483c.066,2.2.31,2.727.4,4.812-.974-1.653-.514-3.629-1.55-4.359-.2-2.586-.535-2.472.015-5.075l-.557.085a9.265,9.265,0,0,1,.77-1.1c-.342.049-.993.747-1.342,1.125.5-2.312,2.8-4.551,5.63-5.6,3.373-1.25,6.543-1.274,8.579.621.235.573.361.58.195.972.5.028.67-.346,1.167-.408-.216.095-.462.673-.678.769,1.151,1.158,1.062,1.551,1.348,3.511a5.015,5.015,0,0,0-.749-1.793,26.311,26.311,0,0,1,.776,2.539,8.36,8.36,0,0,1-.268,2.484c-.312,3.391-.036,3.076-1.389,6.829a21.328,21.328,0,0,0,.032-3.016,31.088,31.088,0,0,0-.154-3.649C1487.851,612.366,1486.916,615.121,1484.759,614.341Z",
    transform: "translate(-1473.945 -607.306)",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22341",
    "data-name": "Group 22341",
    transform: "translate(18.664 11.437)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11428",
    "data-name": "Path 11428",
    d: "M1497.441,690.959l-.273-3.256a7.539,7.539,0,0,0,1.081-1.183c.719-1.189,1.194-1.609,1.548-1.008.172.127.231.533.131,1.037-.173.883-.733,2.2-.908,2.977C1498.88,690.151,1498.064,692.285,1497.441,690.959Z",
    transform: "translate(-1497.167 -685.239)",
    fill: "#ffb27d",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22342",
    "data-name": "Group 22342",
    transform: "translate(29.489 11.08)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11429",
    "data-name": "Path 11429",
    d: "M1570.978,688.528c-.2-4.531.291-.616.531-4.44.472-1.189.784-1.609,1.018-1.008a1.663,1.663,0,0,1,.086,1.037c-.114.883-.481,2.2-.6,2.977C1571.924,687.719,1571.388,689.852,1570.978,688.528Z",
    transform: "translate(-1570.931 -682.808)",
    fill: "#ffb27d",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_22344",
    "data-name": "Group 22344",
    transform: "translate(14.678 43.158)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11430",
    "data-name": "Path 11430",
    d: "M1470.141,901.4a24.989,24.989,0,0,0,3.559.291,10.753,10.753,0,0,0,2.631-.279l.237.932a11.679,11.679,0,0,1-2.868.312,26.167,26.167,0,0,1-3.7-.3Z",
    transform: "translate(-1470.005 -901.396)",
    fill: "#262d4e",
    fillRule: "evenodd"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateEmployeeProfile);
export default __webpack_public_path__ + "static/media/create-employee-profile.c2abdbb781f9e7482b9a0e6a7208b7c4.svg";
export { ForwardRef as ReactComponent };